import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import InputRepository from '@/shared/http/repositories/realestate/input'
import InputsOccurrenceRepository from '@/shared/http/repositories/realestate/inputsoccurrence'
import ActionsForm from '@/shared/mixins/actionsForm'
import {mask} from 'vue-the-mask'
import { loading, toast } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import inputbutton from './components/inputbutton.vue'

export default {
  name: 'searchocurrence',
  props: ['dataDetails', 'statusOcorencia'],
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    HeadDetailsGama,
    inputbutton
  },
  data () {
    return {
      head: ['Nome', 'Data de Inclusão', 'Quantidade', 'Valor', 'Valor Total', ''],
      status: '',
      escritoBotao: true,
      databrower: [],
      searchinsumos: '',
      dataInsumos: [],
      dataOccourenceInput: [],
      AuxdataInsumos: [],
      formNewIput: {
        name: ''
      },
      formeditinsumo: {
        id: '',
        quantidadeMaterial: 0,
        valor: 0
      },
      integerFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      flDisable: false,
      valortotal: 0,
      valorFormatado: ''
    }
  },
  computed: {
    calcularTotal: function () {
      if (this.dataOccourenceInput.length === 0) return '0'

      this.valortotal = this.dataOccourenceInput.reduce((total, element) => {
        return total + element.valorTotal
      }, 0)

      this.valorFormatado = this.formatMoney(this.valortotal)
      return this.valorFormatado
    }
  },
  directives: {mask},
  watch: {
    statusOcorencia (newvalue) {
      this.flDisable = newvalue >= 3 || newvalue < 0
    }
  },
  mounted () {
    this.GetByOccurenceById()
    this.flDisable = this.statusOcorencia >= 3 || this.statusOcorencia < 0
  },

  methods: {
    save () {
      let trocadeaba = 3
      this.$emit('goToDocumentOcurrence', trocadeaba)
    },
    showModal () {
      this.$refs['my-modal'].show()
      this.$bvModal.hide('bv-modal-example')
      this.getInsumos()
    },
    fecharModalAdd () {
      this.$refs['bv-modal-example'].hide()
    },
    buscarinsumos () {
      this.dataInsumos = this.AuxdataInsumos.filter((Element) => Element.name.toUpperCase().includes(this.searchinsumos.toUpperCase()))
    },
    openeditinsumo (data) {
      this.formeditinsumo.id = data.id
      this.formeditinsumo.valor = data.valor
      this.formeditinsumo.quantidadeMaterial = data.quantidadeMaterial
      this.$refs['bv-edit-insu'].show()
    },
    deleteinsumos (data) {
      loading.push()
      InputsOccurrenceRepository.Delete(data.id)
        .then((Response) => {
          this.GetByOccurenceById()
          toast.success('Insumo deletado com sucesso!!')
          loading.pop()
        })
        .catch((Error) => {
          toast.success('Não foi possivel deletar o insumo!!')
          loading.pop()
        })
    },
    hideModal () {
      this.$refs['my-modal'].hide()
    },
    openPoupInsumo () {
      this.$refs['bv-modal-example'].show()
      this.getInsumos()
    },
    getInsumos () {
      loading.push()
      InputRepository.GetAllInsumos()
        .then((Response) => {
          this.dataInsumos = Response.data
          this.AuxdataInsumos = Response.data
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    GetByOccurenceById () {
      loading.push()
      InputsOccurrenceRepository.GetByOccurenceById(this.dataDetails.id)
        .then((Response) => {
          this.dataOccourenceInput = Response.data.data
          loading.pop()
          this.$refs.tableGrids.LoadAllByData(Response)
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    saveinsumos () {
      let lstids = []
      this.$refs.inputbutton.forEach((Element) => {
        if (Element.escritoBotao === false) {
          lstids.push(Element.id)
        }
      })
      let data = {
        InsumosIds: lstids,
        OcorrenciaId: this.dataDetails.id
      }
      loading.push()
      InputsOccurrenceRepository.Post(data)
        .then((Response) => {
          this.fecharModalAdd()
          this.GetByOccurenceById()
          if (Response.data) {
            toast.success('Insumo inserido no chamado com sucesso!!')
          } else {
            toast.error('Não foi possivel salvar insumo no chamado!!')
          }
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    editInsumos () {
      loading.push()
      InputsOccurrenceRepository.Put(this.formeditinsumo)
        .then((Response) => {
          if (Response.data) {
            this.GetByOccurenceById()
            if (Response.data) {
              toast.success('Insumo Alterado com sucesso!')
            } else {
              toast.error('Não foi possivel alterar o insumo!')
            }
            this.fecharModalEditInsu()
            loading.pop()
          }
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    fecharModalEditInsu () {
      this.$refs['bv-edit-insu'].hide()
    },
    back () {
      this.$refs['my-modal'].hide()
      this.openPoupInsumo()
    },
    newInput () {
      loading.push()
      InputRepository.Post(this.formNewIput)
        .then((Response) => {
          if (Response.data) {
            toast.success('Insumo inserido com sucesso!!')
          } else {
            toast.error('Não foi possivel salvar insumo!!')
          }
          this.back()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
          console.error(Error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/InputCosts/inputCosts.js